import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Packageoption.module.css";
import PackageCard from "./PackageCard";
import couple from "./couple image1.webp";

import img5 from "./5.webp";
import img6 from "./6.webp";
import img7 from "./7.webp";
import img8 from "./8.webp";

const images = [img5, img6, img7, img8];
export default function FamilyPackage() {
  const [current, setCurrent] = useState(0);

  // auto carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <main className={styles.pkgContainer}>

      {/* HERO CAROUSEL */}
      <section className={styles.pkgHero}>
        <img src={images[current]} alt="family package" />
      </section>

      {/* HEADER */}
      <section className={styles.pkgHeader}>
      <div>
  <h1 className={styles.pkgTitle}>Meghalaya Family Vacation: The Ultimate Nature Retreat</h1>
  <p className={styles.pkgSubtitle}>
    Create lifelong memories with <b>Atlas Travel House</b>. Enjoy a safe, 
    comfortable, and all-inclusive journey through the waterfalls, caves, 
    and misty hills of the Scotland of the East.
  </p>
</div>

        <div className={styles.pkgPricing}>
          <h2>₹25,000 / person</h2>
          {/* <button className={styles.callBtn}>Call Now</button> */}<a
  href="tel:+919971881444"
  className={styles.callBtn}
  style={{ textDecoration: "none" }}
>
  Call Now
</a>
        </div>
      </section>

        <nav className={styles.toc}>
  <a href="#overview">Overview</a>
  <a href="#itinerary">Itinerary</a>
  <a href="#hotels">Hotels</a>
  <a href="#inclusions">Inclusions</a>
  <a href="#alsocheckout">Also check</a>

</nav>
      {/* OVERVIEW */}
<section id="overview" className={styles.pkgSection}>
  <h2>Family Holiday Overview</h2>
  <ul className={styles.pkgList}>
    <li><b>Duration:</b> 6 Days / 5 Nights – A Relaxed Family Getaway</li>
    <li><b>Destinations:</b> Shillong – Mawlynnong – Dawki – Cherrapunjee – Guwahati</li>
    <li><b>Accommodation:</b> Handpicked Family-Friendly Hotels with Modern Amenities</li>
    <li><b>Transport:</b> Spacious & Safe Private Vehicle for All Sightseeing</li>
    <li><b>Experience:</b> Kid-Friendly Sightseeing & Expert Planning by Atlas Travel House</li>
  </ul>
</section>

  
 

      {/* ITINERARY */}
<section id="itinerary" className={styles.pkgSection}>
  <h2>Your 6-Day Family Adventure: Detailed Itinerary</h2>

  <div className={styles.pkgItinerary}>
    <div className={styles.pkgDay}>
      <h4>Day 1</h4>
      <p>
        Arrival in Guwahati followed by a comfortable scenic drive to Shillong, with a relaxing stop at the picturesque Umiam Lake enroute. Upon arrival, enjoy light local sightseeing (time permitting) before a comfortable overnight stay in Shillong.
      </p>
    </div>

    <div className={styles.pkgDay}>
      <h4>Day 2</h4>
      <p>
        Enjoy a family excursion from Shillong to explore the stunning Krang Suri Falls and Phe Phe Falls, known for their crystal-clear waters and scenic beauty. Return to Shillong by evening for a comfortable overnight stay.
      </p>
    </div>

    <div className={styles.pkgDay}>
      <h4>Day 3</h4>
      <p>
        Enjoy a relaxed journey from Shillong to Cherrapunjee via Mawlynnong, Asia’s cleanest village. Experience the Living Root Bridge at Riwai and the crystal-clear Dawki River (boating optional and family-friendly). Continue to Cherrapunjee for a comfortable overnight stay.
      </p>
    </div>

    <div className={styles.pkgDay}>
      <h4>Day 4</h4>
      <p>
        Enjoy & explore Cherrapunjee’s highlights including Nohkalikai Falls, Seven Sisters Falls, Mawsmai Cave, and Arwah Cave with scenic viewpoints. Later, return to Shillong for a comfortable overnight stay.
      </p>
    </div>

    <div className={styles.pkgDay}>
      <h4>Day 5</h4>
      <p>
        Visit the breathtaking Laitlum Canyon before a comfortable transfer from Shillong to Guwahati. Enjoy an optional Brahmaputra River cruise in the evening, perfect for family leisure time, followed by an overnight stay.
      </p>
    </div>

    <div className={styles.pkgDay}>
      <h4>Day 6</h4>
      <p>
        Enjoy a peaceful visit to the sacred Kamakhya Temple in Guwahati before your scheduled airport transfer for departure.
      </p>
    </div>
  </div>
</section>

      {/* HOTEL INFO */}
<section id="hotels" className={styles.pkgSection}>
  <h2>Hotel Information</h2>

  <div className={styles.hotelBlock}>
    <h3>3★ Standard Hotels (Budget Friendly)</h3>
    <ul className={styles.pkgList}>
      <li><strong>Shillong:</strong> Hotel Alpine Continental / Similar</li>
      <li><strong>Cherrapunjee:</strong> Sa-I-Mika Resort / Similar</li>
      <li><strong>Guwahati:</strong> Hotel Dynasty / Similar</li>
    </ul>
  </div>

  <div className={styles.hotelBlock}>
    <h3>4★ Premium Hotels (Recommended)</h3>
    <ul className={styles.pkgList}>
      <li><strong>Shillong:</strong> IORA Resort / Windermere / Polo Towers</li>
      <li><strong>Cherrapunjee:</strong> Jiva Resort / Similar</li>
      <li><strong>Guwahati:</strong> Hotel Radisson Blu / Royale De Casa</li>
    </ul>
  </div>

</section>

      {/* INCLUSIONS & EXCLUSIONS */}
<section id="inclusions" className={styles.pkgFlex}> 
  <div>
    <h2>What’s Included</h2>
    <ul className={styles.pkgList}>
      <li><b>Stay:</b> 5 nights comfortable hotel accommodation.</li>
      <li><b>Meals:</b> Daily breakfast at all hotels.</li>
      <li><b>Transport:</b> Private vehicle for all transfers & sightseeing.</li>
            <li><b>Entry Fees:</b> Tickets for sightseeing & activities.</li>

      <li><b>Pickup & Drop:</b> Airport pickup and drop included.</li>
      <li><b>Charges:</b> Toll, parking, and driver allowance covered.</li>
    </ul>
  </div>

  <div>
    <h2>Exclusions</h2>
    <ul className={styles.pkgList}>
      <li><b>Flights:</b> Airfare not included.</li>
      <li><b>Meals:</b> Lunch and dinner excluded.</li>
      <li><b>Activities:</b> Boating and other optional charges.</li>
      <li><b>Personal:</b> Any personal expenses.</li>
    </ul>
  </div>
</section>

<section id="alsocheckout" className={styles.pkgSection}>
  <div className={styles.checkoutHeader}>
    <h2 className={styles.checkoutTitle}>Also Checkout</h2>

  <Link to="/meghalayatourpackage" className={styles.viewAll}>
  View All Meghalaya Packages →
</Link>
  </div>

  <div className={styles.checkoutGrid}>
   <PackageCard
      image={couple}
      title="Meghalaya Couple & Honeymoon Special"
      highlights={[
        "<b>Shillong:</b> Romantic café experiences & serene lake walks in Shillong",
        "<b>Cherrapunji:</b> Majestic waterfalls & misty valleys in Cherrapunjee",
        "<b>Dawki:</b> Crystal-clear river boating at Dawki",
        "<b>Mawlynnong:</b> Living Root Bridge & nature walks at Mawlynnong",
        "<b>Stays:</b> Handpicked comfortable stays (3 Star)",
      ]}
      destinations="Shillong – Cherrapunjee – Dawki – Mawlynnong"
      duration="5 Nights / 6 Days"
      price="₹35,000 / person (on twin sharing)"
      detailsLink="/meghalayatourpackage/couple"
    />
  </div>
</section>
    </main>
  );
}